import { Component, HostBinding, Input } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { EntityOverviewItem } from '../entity-overview/entity-overview-item.model';

@Component({
  selector: 'bn-web-ui-entity-overview',
  templateUrl: 'entity-overview.component.html',
  styleUrls: ['entity-overview.component.scss'],
  imports: [FaIconComponent],
})
export class EntityOverviewComponent {
  @Input({ required: true }) items: EntityOverviewItem[] = [];
  @Input() layout: 'grid' | 'stack' = 'grid';

  @HostBinding('class.entity-overview--grid')
  get isGridLayout(): boolean {
    return this.layout === 'grid';
  }

  @HostBinding('class.entity-overview--stack')
  get isStackLayout(): boolean {
    return this.layout === 'stack';
  }
}
